require('./RAObjectiveInfomationNotification.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @ commons
const { OKMessage } = require('commonsComponents/OKMessage');
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const RACircularGoalIcon = require('../../RACircularGoalIcon/RACircularGoalIcon');
const { OKLink } = require('commonsComponents/OKLink');

// @components
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');

// @constants
const {
    GOAL_TRACKING_URL,
    RA_DISASSOCIATE_GOAL_URL,
    RA_REIMBURSEMENT_URL,
    RA_OBJECTIVE_NOTIFICATION_MIN,
    RA_GOAL_NOTIFICATION_MODIFIER_INFORMATIVE,
    RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS,
    RA_GOAL_NOTIFICATION_MODIFIER_WARNING,
} = require('../../../raConstants/index');

// @utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

class RAObjectiveInfomationNotification extends React.Component {
    constructor(props) {
        super(props);
        this.buildContentForSingleObjective = this.buildContentForSingleObjective.bind(
            this,
        );
        this.buildContentForMultipleObjectives = this.buildContentForMultipleObjectives.bind(
            this,
        );
    }

    buildGoalLink(immGoal, isFromMultiple) {
        const { showGoalLink } = this.props;
        const id = immGoal.get('id');
        const name = immGoal.getIn(['goalInformation', 'name']);
        const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
        const formattedGoalDate = moment(goalDate).format('MMM YYYY');
        const url = `${GOAL_TRACKING_URL}/${id}`;
        let content;
        if (isFromMultiple) {
            content = ` (${formattedGoalDate})`;
        }

        let goalText;

        if (showGoalLink) {
            goalText = (
                <OKLink modifier="inline" to={url}>
                    {name}
                </OKLink>
            );
        } else {
            goalText = (
                <span className="ra-objective-information-notification__goal-name">
                    {name}
                </span>
            );
        }

        return (
            <div className="ra-objective-information-notification__multiple-link-wrapper">
                {goalText}
                {content}
            </div>
        );
    }

    buildGoalActionLinks(id, isGoalReachedBefore) {
        let conditionalLink;
        if (isGoalReachedBefore) {
            conditionalLink = (
                <OKLink
                    modifier="widget"
                    extraClass="ra-objective-information-notification__list-items"
                    onClick={() => {
                        this.props.onModifyAmountClick(id);
                    }}
                    inverse={true}
                >
                    <FormattedText value="raObjectiveInfo-raObjectiveInfo_link3" />
                </OKLink>
            );
        }
        const disassociateGoalURL = `${RA_DISASSOCIATE_GOAL_URL}/${id}`;
        const reimbursementLink = `${RA_REIMBURSEMENT_URL}/${id}`;

        return (
            <div className="ra-objective-information-notification__list">
                <OKLink
                    to={disassociateGoalURL}
                    modifier="widget"
                    extraClass="ra-objective-information-notification__list-items"
                    inverse={true}
                >
                    <FormattedText value="raObjectiveInfo-raObjectiveInfo_link1" />
                </OKLink>
                <OKLink
                    to={reimbursementLink}
                    modifier="widget"
                    extraClass="ra-objective-information-notification__list-items"
                    inverse={true}
                >
                    <FormattedText value="raObjectiveInfo-raObjectiveInfo_link2" />
                </OKLink>
                {conditionalLink}
            </div>
        );
    }

    buildGoalInfoContent(immGoal, isFromMultple) {
        const { userName } = this.props;
        const goalProgress = immGoal.getIn(['goalInformation', 'goalProgress']);
        const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
        const formattedGoalDate = moment(goalDate).format('MMM YYYY');
        const goalLink = this.buildGoalLink(immGoal);
        const goalTitle = isFromMultple
            ? 'multipleGoalTitle'
            : 'singleGoalTitle';
        let firstLineInfoKey;
        let infoContent;

        if (isFromMultple) {
            infoContent = [goalLink, formattedGoalDate];
        } else {
            infoContent = [userName, goalLink, formattedGoalDate];
        }

        if (goalProgress >= 1) {
            const isGoalReachedBefore = moment(goalDate).isAfter(
                moment(),
                'day',
            );
            const infoNumberKey = isGoalReachedBefore ? 4 : 5;
            firstLineInfoKey = `raObjectiveInfo-raObjectiveInfo_${goalTitle}${infoNumberKey}`;
        } else {
            firstLineInfoKey = `raObjectiveInfo-raObjectiveInfo_${goalTitle}3`;
        }

        return (
            <FormattedTextWithComponents
                value={firstLineInfoKey}
                injectedComponents={infoContent}
                className="ra-objective-information-notification__info-text"
            />
        );
    }

    buildContentForSingleObjective(immGoal) {
        const id = immGoal.get('id');
        const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
        const goalType = immGoal.getIn(['goalInformation', 'goalType']);
        const goalProgress = immGoal.getIn(['goalInformation', 'goalProgress']);
        const title = formatText('raObjectiveInfo-raObjectiveInfo_headerTitle');
        let actionLinks;
        let modifier;
        let singleGoalInfoKey = 3;

        if (goalProgress >= 1) {
            const isGoalReachedBefore = moment(goalDate).isAfter(
                moment(),
                'day',
            );
            actionLinks = this.buildGoalActionLinks(id, isGoalReachedBefore);
            modifier = RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS;
            singleGoalInfoKey = isGoalReachedBefore ? 2 : 3;
        } else {
            const disassociateGoalURL = `${RA_DISASSOCIATE_GOAL_URL}/${id}`;
            actionLinks = (
                <OKLink
                    to={disassociateGoalURL}
                    modifier="widget"
                    inverse={true}
                    extraClass="ra-objective-information-notification__list-items"
                >
                    <FormattedText value="raObjectiveInfo-raObjectiveInfo_link1" />
                </OKLink>
            );
            modifier = RA_GOAL_NOTIFICATION_MODIFIER_WARNING;
        }
        const singleGoalInfo = `raObjectiveInfo-raObjectiveInfo_singleGoalInfo${singleGoalInfoKey}`;
        const infoContent = this.buildGoalInfoContent(immGoal);

        return (
            <BlockInfo extraClass="ra-objective-information-notification__block-info">
                <OKMessage
                    type="information"
                    title={title}
                    closeButton={true}
                    customIcon={
                        <RACircularGoalIcon
                            type={goalType}
                            modifier={modifier}
                        />
                    }
                    onCloseButtonClick={this.props.onClose}
                >
                    <div>
                        {infoContent}
                        <FormattedText
                            className="ra-objective-information-notification__info-text"
                            value="raObjectiveInfo-raObjectiveInfo_singleGoalInfo1"
                        />
                    </div>
                    {actionLinks}
                    <FormattedText
                        className="ra-objective-information-notification__info-text"
                        value={singleGoalInfo}
                    />
                </OKMessage>
            </BlockInfo>
        );
    }

    buildMultipleGoalLinks(immGoals) {
        if (immGoals.size === RA_OBJECTIVE_NOTIFICATION_MIN) {
            return this.buildGoalLink(immGoals.first(), true);
        } else {
            const initialLinks = this.buildMultipleGoalLinks(
                immGoals.slice(
                    0,
                    immGoals.size - RA_OBJECTIVE_NOTIFICATION_MIN,
                ),
            );
            const lastLink = this.buildGoalLink(immGoals.last(), true);
            return (
                <FormattedTextWithComponents
                    value="raObjectiveInfo-raObjectiveInfo_multipleInitialLinks"
                    injectedComponents={[initialLinks, lastLink]}
                />
            );
        }
    }

    buildGoalsContent(immGoals, translationKey) {
        let goalsContent;
        if (immGoals.size === RA_OBJECTIVE_NOTIFICATION_MIN) {
            const immGoal = immGoals.first();
            goalsContent = this.buildGoalInfoContent(immGoal, true);
        } else if (immGoals.size > RA_OBJECTIVE_NOTIFICATION_MIN) {
            const immPartialsGoals = immGoals.slice(0, immGoals.size - 1);
            const immLastGoal = immGoals.last();
            const initialLinks = this.buildMultipleGoalLinks(immPartialsGoals);
            const lastLink = this.buildGoalLink(immLastGoal, true);
            const allLinks = (
                <FormattedTextWithComponents
                    value="raObjectiveInfo-raObjectiveInfo_multipleLastLink"
                    injectedComponents={[initialLinks, lastLink]}
                />
            );

            goalsContent = (
                <FormattedTextWithComponents
                    value={translationKey}
                    injectedComponents={[allLinks]}
                    className="ra-objective-information-notification__info-text"
                />
            );
        }

        return goalsContent;
    }

    buildContentForMultipleObjectives(immGoals) {
        const { userName } = this.props;
        const immGoalsReachedBeforeDate = immGoals.filter(immGoal => {
            const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
            const goalProgress = immGoal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            return (
                goalProgress >= 1 && moment(goalDate).isAfter(moment(), 'day')
            );
        });
        const immGoalsReachedOnDate = immGoals.filter(immGoal => {
            const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
            const goalProgress = immGoal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            return (
                goalProgress >= 1 &&
                moment(goalDate).isSameOrBefore(moment(), 'day')
            );
        });

        const immGoalsNonReached = immGoals.filter(immGoal => {
            const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
            const goalProgress = immGoal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            return (
                goalProgress < 1 &&
                moment(goalDate).isSameOrBefore(moment(), 'day')
            );
        });

        const beforeDateTranslationKey =
            'raObjectiveInfo-raObjectiveInfo_multipleGoalInfo1';
        const onDateTranslationKey =
            'raObjectiveInfo-raObjectiveInfo_multipleGoalInfo2';
        const nonReachedTranslationKey =
            'raObjectiveInfo-raObjectiveInfo_multipleGoalInfo3';
        const goalsReachedBeforeDateContent = this.buildGoalsContent(
            immGoalsReachedBeforeDate,
            beforeDateTranslationKey,
        );
        const goalsReachedOnDateContent = this.buildGoalsContent(
            immGoalsReachedOnDate,
            onDateTranslationKey,
        );
        const goalsNonReached = this.buildGoalsContent(
            immGoalsNonReached,
            nonReachedTranslationKey,
        );
        const title = formatText('raObjectiveInfo-raObjectiveInfo_headerTitle');
        const userInfo = (
            <FormattedTextWithComponents
                value="raObjectiveInfo-raObjectiveInfo_multipleGoalTitle"
                injectedComponents={[userName]}
            />
        );
        let modifier = RA_GOAL_NOTIFICATION_MODIFIER_SUCCESS;
        if (immGoalsNonReached.size >= 1) {
            if (
                immGoalsReachedBeforeDate.size >= 1 ||
                immGoalsReachedOnDate.size >= 1
            ) {
                modifier = RA_GOAL_NOTIFICATION_MODIFIER_INFORMATIVE;
            } else {
                modifier = RA_GOAL_NOTIFICATION_MODIFIER_WARNING;
            }
        }

        return (
            <BlockInfo extraClass="ra-objective-information-notification__block-info">
                <div className="ra-objective-information-notification__block-info__content">
                    <OKMessage
                        type="information"
                        closeButton={true}
                        title={title}
                        customIcon={<RACircularGoalIcon modifier={modifier} />}
                        onCloseButtonClick={this.props.onClose}
                    >
                        <div>
                            {userInfo}
                            {goalsReachedBeforeDateContent}
                            {goalsReachedOnDateContent}
                            {goalsNonReached}
                            <FormattedText
                                className="ra-objective-information-notification__info-text"
                                value="raObjectiveInfo-raObjectiveInfo_multipleGoalFooter"
                            />
                        </div>
                    </OKMessage>
                </div>
            </BlockInfo>
        );
    }

    render() {
        const { goalData } = this.props;
        const immActiveGoals = goalData.filter(immGoal => {
            const goalProgress = immGoal.getIn([
                'goalInformation',
                'goalProgress',
            ]);
            const goalDate = immGoal.getIn(['goalInformation', 'goalDate']);
            const goalReached = goalProgress >= RA_OBJECTIVE_NOTIFICATION_MIN;
            const goalNonReached =
                goalProgress < RA_OBJECTIVE_NOTIFICATION_MIN &&
                moment(goalDate).isSameOrBefore(moment(), 'day');

            return (
                (goalReached || goalNonReached) &&
                !immGoal.getIn(['state', 'cancelled'])
            );
        });
        let content = null;

        if (immActiveGoals.size === RA_OBJECTIVE_NOTIFICATION_MIN) {
            const immGoal = immActiveGoals.first();
            content = this.buildContentForSingleObjective(immGoal);
        } else if (immActiveGoals.size > RA_OBJECTIVE_NOTIFICATION_MIN) {
            content = this.buildContentForMultipleObjectives(immActiveGoals);
        }

        return content;
    }
}

RAObjectiveInfomationNotification.propTypes = {
    goalData: PropTypes.object.isRequired,
    userName: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    onModifyAmountClick: PropTypes.func.isRequired,
    showGoalLink: PropTypes.bool,
};

RAObjectiveInfomationNotification.defaultProps = {
    showGoalLink: true,
};

module.exports = RAObjectiveInfomationNotification;
